import axios from "axios";
import { API_BASE as SBIN_API_BASE } from "./base";

const API = SBIN_API_BASE;

const authHeaders = (token) => {
  const authToken = token || null;
  return authToken
    ? {
        Authorization: `Bearer ${authToken}`,
        "Content-Type": "application/json",
      }
    : { "Content-Type": "application/json" };
};

export async function getMaintenanceTasks(params = {}, token) {
  const res = await axios.get(`${API}/maintenance/tasks`, {
    params,
    headers: authHeaders(token),
  });
  return res.data;
}

export async function createMaintenanceTask(payload, token) {
  const res = await axios.post(`${API}/maintenance/tasks`, payload, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function updateMaintenanceTask(taskId, payload, token) {
  const res = await axios.put(`${API}/maintenance/tasks/${taskId}`, payload, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function deactivateMaintenanceTask(taskId, token) {
  const res = await axios.delete(`${API}/maintenance/tasks/${taskId}`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function completeMaintenanceTask(taskId, payload = {}, token) {
  const res = await axios.post(
    `${API}/maintenance/tasks/${taskId}/complete`,
    payload,
    {
      headers: authHeaders(token),
    }
  );
  return res.data;
}

export async function getMaintenanceTaskLogs(taskId, params = {}, token) {
  const res = await axios.get(`${API}/maintenance/tasks/${taskId}/logs`, {
    params,
    headers: authHeaders(token),
  });
  return res.data;
}

export async function seedMaintenanceDefaults(token) {
  const res = await axios.post(
    `${API}/maintenance/tasks/seed-defaults`,
    {},
    {
      headers: authHeaders(token),
    }
  );
  return res.data;
}

export async function getComplianceReferences(token) {
  const res = await axios.get(`${API}/maintenance/compliance-references`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function createComplianceReference(payload, token) {
  const res = await axios.post(
    `${API}/maintenance/compliance-references`,
    payload,
    {
      headers: authHeaders(token),
    }
  );
  return res.data;
}

export async function updateComplianceReference(referenceId, payload, token) {
  const res = await axios.put(
    `${API}/maintenance/compliance-references/${referenceId}`,
    payload,
    {
      headers: authHeaders(token),
    }
  );
  return res.data;
}

export async function deleteComplianceReference(referenceId, token) {
  const res = await axios.delete(
    `${API}/maintenance/compliance-references/${referenceId}`,
    {
      headers: authHeaders(token),
    }
  );
  return res.data;
}
